import { Component, OnDestroy, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { InfoGridComponent } from '@3ddv/software-division-components/backoffice/info-grid';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { RedisManagerService } from '../../services/redis-manager.service';

@Component({
  selector: 'app-delete-all',
  templateUrl: './delete-all.component.html',
  imports: [BoDialogComponent, ButtonComponent, InfoGridComponent],
})
export class DeleteAllComponent implements OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private redisManagerService = inject(RedisManagerService);
  private toastrService = inject(ToastrService);

  readonly keys = input.required<string[]>();

  private subscriptions: Array<Subscription>;
  private waitingApi: boolean;
  constructor() {
    this.subscriptions = [];
    this.waitingApi = false;
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm() {
    if (this.waitingApi) return;
    this.waitingApi = true;
    this.redisManagerService.deleteKeys$(this.keys()).subscribe({
      next: () => {
        this.onDismiss('success');
      },
      error: () => {
        this.toastrService.error(
          'An error occurred trying to delete all redis keys',
          'Error'
        );
      },
    });
  }
}
